// extracted by css-extract-rspack-plugin
export default {"wrapper":"N58nL","formatting":"uCewl","error":"LDrpu","toolbar":"bH5fu","toolbarButton":"RXJqK","editor":"QauBx","tooltips":"FDe7C","shortcuts":"p4rVp"};